"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MessageBar", {
    enumerable: true,
    get: function() {
        return MessageBar;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useMessageBar = require("./useMessageBar");
const _renderMessageBar = require("./renderMessageBar");
const _useMessageBarStylesstyles = require("./useMessageBarStyles.styles");
const _useMessageBarContextValues = require("./useMessageBarContextValues");
const MessageBar = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMessageBar.useMessageBar_unstable)(props, ref);
    (0, _useMessageBarStylesstyles.useMessageBarStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMessageBarStyles_unstable')(state);
    return (0, _renderMessageBar.renderMessageBar_unstable)(state, (0, _useMessageBarContextValues.useMessageBarContextValue_unstable)(state));
});
MessageBar.displayName = 'MessageBar';
